import { environment } from 'src/environments/environment';

export const BASE_URL = environment.nodeApiUrl + '/' + environment.api_prefix;

/**
 * Marker that sends a request path to the v2 API instead of v1 — stripped and swapped for the v2
 * base by `ApiService.resolveUrl()`.
 *
 * Only the New Project Insight report's content endpoints exist on v2 (see
 * docs/backend/project-insights/FRONTEND-NEW-PROJECT-INSIGHT-2026-09-15.md); every other path 404s there. So this
 * is never written by hand at a call site — `ReportService.versionedPath()` is the single place
 * that decides a request belongs on v2 and prepends it.
 *
 * Starts with `@` so it can never collide with a real path, which always starts with `/`.
 */
export const V2_PATH_PREFIX = '@v2';
